import { gql } from 'apollo-boost'


export const PARTNER_DATA = gql`query damage_partner($partner_id: String = "" ) {
    damage_partner( where: { partner_id: { _eq: $partner_id }} ) {
      activated      
      color_highlight
      color_primary
      color_secondary
      dam_logo_id
      form_submits_email_targets
      id      
      partner_id
      partner_name
      partner_website
      color_damage_selection
      can_book_weekends
      outro_title
      outro_text
      step1_text
      step1_title
      step3_title
      step3_text 
      blocked_days_selected
      blocked_days
      require_insurance_company_info          
    }
  }`


  export const FORM_SUBMIT = gql`query damage_form_submit($id: uuid = "") {
    damage_form_submit(where: {id: {_eq: $id}}) {
      email
      date
      emailed_ts
      full_name
      id
      info
      insurance_company_name
      insurance_damage_number
      meter_reading
      overview_image_url
      partner_id
      phone
      postal_code
      reg_nr
      session_id
      submitted_ts
      model
      model_specific
      make
      damaged_areas {
        area_name
      }
    }
  }  
  `


export const VALIDATION_TOKEN = gql`
 query validation_sequence {
    api_current_validation_sequence {
        validation_sequence
    }
    
}
`;